import React, { FC, useState } from "react";
import {
  faAdd,
  faCalendarPen,
  faPenToSquare,
  faSearch,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { t } from "i18next";
import ButtonAdd from "../atoms/ButtonAdd";

type TrainingOptions = {
  id: number | string;
  namePlan: string;
  dateInterval: string;
  assignedBy: string;
  state: string;
  porcentage?: string;
};

type AlgorismOptions = {
  id: number | string;
  label: string;
  action: () => void;
  loader?: boolean;
  icon: React.ReactNode;
  actions?: {
    action: () => void;
    icon: React.ReactNode;
    label: string;
  }[];
};

type ListTrainingPlanProps = {
  options: TrainingOptions[];
  title: string;
  button: React.ReactNode;
  onCreate: () => void;
  onEditActive?: () => void;
  onEditPlanned?: () => void;
  onSearch?: () => void;
  onClickAdd?: () => void;
  onClickPlan?: () => void;
  onNewPlan?: () => void;
  algorismOptions?: AlgorismOptions[];
  newPlanOptions?: AlgorismOptions[];
  onTitleClick?: (id: number | any) => void;
  loader: boolean;
};

export const ListTrainingPlan: FC<ListTrainingPlanProps> = ({
  options,
  title,
  button,
  onClickAdd,
  onClickPlan,
  onCreate,
  onEditActive,
  onEditPlanned,
  onNewPlan,
  onSearch,
  algorismOptions,
  newPlanOptions,
  onTitleClick,
  loader,
}) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [isNewPlanOpen, setIsNewPlanOpen] = useState(false);

  console.log("algorismOptions", algorismOptions);

  const handleToggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleNewPlanToggle = () => {
    setIsNewPlanOpen((prev) => !prev);
  };

  const handleNewPlanOptionClick = (action: () => void) => {
    action();
    setIsNewPlanOpen(false);
  };

  if (loader) {
    return (
      <div className="w-full mt-4 animate-pulse">
        <div className="h-6 bg-gray-300 rounded w-1/4 mb-4"></div>
        <div className="h-10 bg-gray-200 rounded w-full mb-4"></div>
        {[...Array(5)]?.map((_, index) => (
          <div
            key={index}
            className="flex items-center justify-between py-5 border-b"
          >
            <div className="w-3/4 h-4 bg-gray-200 rounded"></div>
            <div className="w-1/6 h-4 bg-gray-300 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  const sortedOptions =
    options && options?.length > 0
      ? [...options].sort((a, b) => {
          if (a.state === "ACTIVO" && b.state !== "ACTIVO") return -1;
          if (b.state === "ACTIVO" && a.state !== "ACTIVO") return 1;
          return 0;
        })
      : options;

  return (
    <>
      <div className="w-full mt-4">
        {/* Header with title and buttons */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4 px-2">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {title}
          </h1>
          <div className="flex gap-4 lg:gap-0 mt-4 lg:mt-0 lg:flex-row lg:space-x-4">
            {button}
            <Menu as="div" className="relative flex-none mt-1 md:mt-0">
              <MenuButton className="-m-2.5 block p-2.5 text-gray-500 hover:text-gray-900">
                <span className="sr-only">{t("trainingPlan.openOptions")}</span>
                <ButtonAdd functionButton={() => {}} />
              </MenuButton>
              <MenuItems
                transition
                className="absolute md:right-0 z-50 mt-2 w-60 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                {algorismOptions &&
                  algorismOptions?.length > 0 &&
                  algorismOptions?.map?.((option, index) => (
                    <div key={index}>
                      <MenuItem>
                        {option?.loader && (
                          <div className="flex items-center justify-center">
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900"></div>
                          </div>
                        )}
                        <a
                          onClick={() => handleToggle(index)}
                          className="flex items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4 cursor-pointer"
                        >
                          {option ? option?.label : ""}
                        </a>
                      </MenuItem>
                      {activeIndex === index && option?.actions && (
                        <div className="pl-4">
                          {option &&
                            option?.actions?.map((action, actionIndex) => (
                              <MenuItem key={actionIndex}>
                                <a
                                  onClick={action.action}
                                  className="flex items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4 cursor-pointer"
                                >
                                  {action ? action?.label : ""}
                                </a>
                              </MenuItem>
                            ))}
                        </div>
                      )}
                    </div>
                  ))}
                <div>
                  <div
                    onClick={handleNewPlanToggle}
                    className="flex items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4 cursor-pointer"
                  >
                    <FontAwesomeIcon icon={faAdd} />
                    {t("trainingPlan.newAlgorithmPlan")}
                  </div>
                </div>
                {isNewPlanOpen && newPlanOptions && (
                  <div className="pl-4">
                    {newPlanOptions &&
                      newPlanOptions?.map?.((option, index) => (
                        <MenuItem key={index}>
                          <a
                            onClick={() =>
                              handleNewPlanOptionClick(option.action)
                            }
                            className="flex items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4 cursor-pointer"
                          >
                            {option?.label ?? ""}
                          </a>
                        </MenuItem>
                      ))}
                  </div>
                )}
                {onEditPlanned && (
                  <MenuItem>
                    <a
                      className="flex items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4 cursor-pointer"
                      onClick={onEditPlanned}
                    >
                      <FontAwesomeIcon icon={faCalendarPen} />
                      {t("trainingPlan.modifyPlannedPlan")}
                    </a>
                  </MenuItem>
                )}
                {onEditActive && (
                  <MenuItem>
                    <a
                      className="flex items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4 cursor-pointer"
                      onClick={onEditActive}
                    >
                      <FontAwesomeIcon icon={faPenToSquare} />
                      {t("trainingPlan.modifyActivePlan")}
                    </a>
                  </MenuItem>
                )}
                <MenuItem>
                  <a
                    className="flex items-center px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50 text-left gap-4 cursor-pointer"
                    onClick={onSearch}
                  >
                    <FontAwesomeIcon icon={faSearch} />
                    {t("trainingPlan.searchPlan")}
                  </a>
                </MenuItem>
              </MenuItems>
            </Menu>
          </div>
        </div>
        <hr className="border-gray-300 mb-4" />
        <ul
          role="list"
          className="divide-y divide-gray-100 px-2 h-96 overflow-auto"
        >
          {sortedOptions &&
            sortedOptions?.length > 0 &&
            sortedOptions?.map((option: any) => (
              <li
                onClick={onClickPlan}
                key={`training-plan-${option.id}-${Math.floor(Math.random() * 100)}`}
                className={`${
                  option.state === "ACTIVO" || option.state === "PLANEADO"
                    ? "opacity-100"
                    : "opacity-50"
                } flex flex-wrap items-center justify-between gap-x-6 py-5`}
              >
                <div className="min-w-0">
                  <div className="flex items-start gap-x-3">
                    <p
                      className="text-sm font-semibold leading-6 text-gray-900 cursor-pointer"
                      onClick={() => {
                        if (onTitleClick) {
                          onTitleClick(option?.position);
                        }
                      }}
                    >
                      {option.namePlan}
                    </p>
                    <p
                      className={`${
                        option.state === "ACTIVO"
                          ? "text-green-600 bg-green-50 ring-green-500/10"
                          : option.state === "COMPLETADO" ||
                              option.state === "INACTIVO"
                            ? "text-indigo-600 bg-indigo-50 ring-indigo-500/10"
                            : option.state === "PLANEADO"
                              ? "text-yellow-600 bg-yellow-50 ring-yellow-500/10"
                              : "text-gray-600 bg-gray-50 ring-gray-500/10"
                      } mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset`}
                    >
                      {option?.state === "INACTIVO"
                        ? t("trainingPlan.completed")
                        : t(`trainingPlan.${option?.state.toLowerCase()}`)}
                    </p>
                  </div>
                  <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                    <p className="whitespace-nowrap">
                      <time dateTime={option?.dateInterval}>
                        {option?.dateInterval}
                      </time>
                    </p>
                    <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                      <circle r={1} cx={1} cy={1} />
                    </svg>
                    <p className="truncate">
                      {t("lead.views.create_by")} {option?.assignedBy}
                    </p>
                  </div>
                </div>
                {option?.porcentage && (
                  <div className="w-full lg:w-auto mt-4 lg:mt-0">
                    <div className="mt-1 grid place-items-center leading-5 text-gray-500">
                      <p className="flex items-center justify-center mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-base font-medium ring-1 ring-inset text-indigo-600 bg-indigo-50 ring-indigo-500/10 mr-5">
                        {/* {option.porcentage} */}0%
                      </p>
                    </div>
                  </div>
                )}
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};
